// MapSelector.js
import React, {useEffect, useState} from "react";
import {MapContainer, TileLayer, Marker, useMapEvents, useMap} from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";

import "./RaikoLeafletMap.scss"

import markerIcon2x from "./img/marker-icon-2x.png";
import markerIcon from "./img/marker-icon.png";
import markerShadow from "./img/marker-shadow.png";
import {RaikoLeafletIranProvinces} from "./RaikoLeafletIranProvinces";

// لازم چون Leaflet آیکون پیش‌فرض نداره در محیط React
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    // iconRetinaUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png",
    // iconUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png",
    // shadowUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png",

    iconRetinaUrl: markerIcon2x,
    iconUrl: markerIcon,
    shadowUrl: markerShadow,


});

function LocationMarker({onSelect,selectedPosition = null}) {

    useEffect(() => {
        setPosition(selectedPosition);
    }, [selectedPosition]);

    const [position, setPosition] = useState(selectedPosition);

    useMapEvents({
        click(e) {
            const {lat, lng} = e.latlng;
            setPosition([lat, lng]);
            onSelect({lat, lng});
        },
    });

    return position ? <Marker position={position}></Marker> : null;
}

export default function RaikoLeafletMap(
    {
        centerLocation = RaikoLeafletIranProvinces.Tehran,
        centerPoint,
        latPoint,
        lngPoint,
        setLatPoint,
        setLngPoint,
    }) {

    const [selected, setSelected] = useState(null);

    useEffect(() => {
        if (
            typeof latPoint !== "undefined" &&
            typeof lngPoint !== "undefined" &&
            latPoint !== null && lngPoint !== null
        ) {
            setSelected([latPoint, lngPoint]);
        }

    }, [latPoint, lngPoint]);

    useEffect(() => {
        if (typeof selected !== "undefined" && selected !== null && selected.lat) {
            setLatPoint(selected.lat);
            setLngPoint(selected.lng);
        }
    }, [selected])

    function ChangeMapView({ centerLocation, centerPoint }) {
        const map = useMap();

        useEffect(() => {
            const center = centerPoint || centerLocation.point;
            const zoom = centerPoint ? 13 : centerLocation.zoom;

            map.flyTo(center, zoom, {
                animate: true,
                duration: 1.2,
            });
        }, [centerLocation, centerPoint]);

        return null;
    }


    return (
        <div className={"baseLeafletMapContainer"}>
            <MapContainer
                center={centerPoint ? centerPoint : centerLocation.point}
                zoom={centerPoint ? 13 : centerLocation.zoom}
                style={{height: "100%", width: "100%"}}
            >
                <ChangeMapView
                    centerLocation={centerLocation}
                    centerPoint={centerPoint}
                />
                <TileLayer
                    url="https://tile.openstreetmap.de/{z}/{x}/{y}.png"
                    attribution="&copy; OpenStreetMap contributors"
                />
                <LocationMarker
                    onSelect={(coords) => setSelected(coords)}
                    selectedPosition={selected}
                />
            </MapContainer>
        </div>
    );
}
